@if (!isLink) {
  <a
    class="anchor-link"
    href="javascript:void(0)"
    (click)="onLinkClick()"
    [ngClass]="{ 'show-under-line': showUnderLine }"
    [ngStyle]="styleConfig"
    role="button"
    [attr.aria-label]="text"
    [attr.aria-pressed]="isPressed"
    tabindex="0"
    (keydown.enter)="onLinkClick()"
    (keydown.space)="onLinkClick(); $event.preventDefault()"
  >
    <span [ngStyle]="styleConfig">{{ text }}</span>
  </a>
}
@if (isLink) {
  <a
    class="anchor-link"
    [href]="link"
    (click)="onLinkClick()"
    [target]="target"
    [ngClass]="{ 'show-under-line': showUnderLine }"
    [ngStyle]="styleConfig"
    [attr.aria-label]="text"
    [attr.aria-description]="target === '_blank' ? 'Opens in new tab' : ''"
    [attr.rel]="target === '_blank' ? 'noopener noreferrer' : ''"
  >
    <span [ngStyle]="styleConfig">{{ text }}</span>
    @if (target === '_blank') {
      <span class="visually-hidden">(opens in new tab)</span>
    }
  </a>
}
